<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">雇佣信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.serviceStatus == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.serviceStatus : enNameMap.serviceStatus
              "
            >
              <Select
                :clearable="true"
                v-model="formItem.servicestatus"
                :disabled="disableSelfData.serviceStatus == 0"
              >
                <Option
                  v-for="item in workStatus"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hireDate == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.hireDate : enNameMap.hireDate"
            >
              <DatePicker
                :disabled="disableSelfData.hireDate == 0"
                type="date"
                v-model="formItem.hiredate"
                @on-change="getCompanyFront"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hireValid == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.hireValid : enNameMap.hireValid"
            >
              <DatePicker
                :disabled="disableSelfData.hireValid == 0"
                type="date"
                v-model="formItem.hirevalid"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hireSociety == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.hireSociety : enNameMap.hireSociety
              "
            >
              <DatePicker
                :disabled="disableSelfData.hireSociety == 0"
                type="date"
                v-model="formItem.hiresociety"
                @on-change="getsocialFront"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.syStartDate == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.syStartDate : enNameMap.syStartDate
              "
            >
              <RadioGroup
                v-model="formItem.systartdate"
                :disabled="disableSelfData.syStartDate == 0"
              >
                <Radio
                  v-for="item in BeginningdateService"
                  :label="item.value"
                  :key="item.value"
                  >{{ item.label }}</Radio
                >
              </RadioGroup>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.issyadjust == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.issyadjust : enNameMap.issyadjust
              "
            >
              <Checkbox
                v-model="formItem.issyadjust"
                :disabled="disableSelfData.issyadjust == 0"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.syadjust == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.syadjust : enNameMap.syadjust"
            >
              <Input
                :disabled="disableSelfData.syadjust == 0"
                v-model="formItem.syadjust"
                @on-change="getCompanyAfter"
              />
            </FormItem>
          </div>
          <div
            class="formCol"
            v-if="
              showSelfData.companyAgeFront == '1' ||
                showSelfData.companyAgeAfter == '1'
            "
          >
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.companyAgeFrontOrAfter
                  : enNameMap.companyAgeFrontOrAfter
              "
            >
              <Input
                :disabled="disableSelfData.companyAgeFront == 0"
                v-model="formItem.companyAgeFront"
                v-if="showSelfData.companyAgeFront == '1'"
                style="width:48%;"
              />
              <Input
                :disabled="disableSelfData.companyAgeAfter == 0"
                v-model="formItem.companyAgeAfter"
                v-if="showSelfData.companyAgeAfter == '1'"
                style="width:48%;margin-left:1%"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.isswadjust == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.isswadjust : enNameMap.isswadjust
              "
            >
              <Checkbox
                v-model="formItem.isswadjust"
                :disabled="disableSelfData.isswadjust == 0"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.swadjust == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.swadjust : enNameMap.swadjust"
            >
              <Input
                :disabled="disableSelfData.swadjust == 0"
                v-model="formItem.swadjust"
                @on-change="getsocialAfter"
              />
            </FormItem>
          </div>
          <div
            class="formCol"
            v-if="
              showSelfData.socialAgeFront == '1' ||
                showSelfData.socialAgeAfter == '1'
            "
          >
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.socialAgeFrontOrAfter
                  : enNameMap.socialAgeFrontOrAfter
              "
            >
              <Input
                :disabled="disableSelfData.socialAgeFront == 0"
                v-model="formItem.socialAgeFront"
                v-if="showSelfData.socialAgeFront == '1'"
                style="width:48%;"
              />
              <Input
                :disabled="disableSelfData.socialAgeAfter == 0"
                v-model="formItem.socialAgeAfter"
                v-if="showSelfData.socialAgeAfter == '1'"
                style="width:48%;margin-left:1%"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.superVisor == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.superVisor : enNameMap.superVisor
              "
            >
              <Input
                :disabled="disableSelfData.superVisor == 0"
                v-model="formItem.supervisor"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hrStatus == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.hrStatus : enNameMap.hrStatus"
            >
              <Select
                :clearable="true"
                v-model="formItem.hrstatus"
                :disabled="disableSelfData.hrStatus == 0"
              >
                <Option
                  v-for="item in personnelStatus"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.inProbation == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.inProbation : enNameMap.inProbation
              "
            >
              <Checkbox
                v-model="formItem.inprobation"
                :disabled="disableSelfData.inProbation == 0"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.probationEndDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.probationEndDate
                  : enNameMap.probationEndDate
              "
            >
              <DatePicker
                :disabled="disableSelfData.probationEndDate == 0"
                type="date"
                v-model="formItem.probationenddate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.retireClass == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.retireClass : enNameMap.retireClass
              "
            >
              <Select
                :disabled="disableSelfData.retireClass == 0"
                v-model="formItem.retireclass"
              >
                <Option
                  v-for="(item, index) in retireClass"
                  :key="index"
                  :value="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.retirementYears == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.retirementYears
                  : enNameMap.retirementYears
              "
            >
              <Input
                :disabled="disableSelfData.retirementYears == 0"
                v-model="formItem.retirementYears"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.tempEmp == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.tempEmp : enNameMap.tempEmp"
            >
              <Checkbox
                :disabled="disableSelfData.tempEmp == 0"
                v-model="formItem.tempemp"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.expatriate == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.expatriate : enNameMap.expatriate
              "
            >
              <Checkbox
                :disabled="disableSelfData.expatriate == 0"
                v-model="formItem.expatriate"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.labourWorker == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.labourWorker : enNameMap.labourWorker
              "
            >
              <Checkbox
                :disabled="disableSelfData.labourWorker == 0"
                v-model="formItem.labourworker"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.holidayClass == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.holidayClass : enNameMap.holidayClass
              "
            >
              <Select
                :disabled="disableSelfData.holidayClass == 0"
                v-model="formItem.holidayclass"
              >
                <Option
                  v-for="(item, index) in HOLIDAYCLASS"
                  :key="index"
                  :value="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.anlvclass == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.anlvclass : enNameMap.anlvclass"
            >
              <Select
                :disabled="disableSelfData.anlvclass == 0"
                v-model="formItem.anlvclass"
              >
                <Option
                  v-for="(item, index) in ANLVCLASS"
                  :key="index"
                  :value="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol"></div>
        </div>
      </Form>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">其他信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.hrLevel == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.hrLevel : enNameMap.hrLevel"
            >
              <Select
                :clearable="true"
                v-model="formItem.hrlevel"
                :disabled="disableSelfData.hrLevel == 0"
              >
                <Option
                  v-for="item in personnelLevel"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.levelGrade == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.levelGrade : enNameMap.levelGrade
              "
            >
              <Input
                :disabled="disableSelfData.levelGrade == 0"
                v-model="formItem.levelgrade"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hireType == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.hireType : enNameMap.hireType"
            >
              <Select
                :clearable="true"
                v-model="formItem.hiretype"
                :disabled="disableSelfData.hireType == 0"
              >
                <Option
                  v-for="item in partisanList"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.nextReviewDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.nextReviewDate
                  : enNameMap.nextReviewDate
              "
            >
              <DatePicker
                :disabled="disableSelfData.nextReviewDate == 0"
                type="date"
                v-model="formItem.nextreviewdate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.inFrom == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.inFrom : enNameMap.inFrom"
            >
              <Select
                :clearable="true"
                v-model="formItem.in_from"
                :disabled="disableSelfData.inFrom == 0"
              >
                <Option
                  v-for="item in PersonnelBackground"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.hireSource == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.hireSource : enNameMap.hireSource
              "
            >
              <Input
                :disabled="disableSelfData.hireSource == 0"
                v-model="formItem.hiresource"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.labourWorker == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.laborBook : enNameMap.laborBook"
            >
              <Input
                :disabled="disableSelfData.labourWorker == 0"
                v-model="formItem.laborbook"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.saemp == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.saemp : enNameMap.saemp">
              <Checkbox
                v-model="formItem.saemp"
                :disabled="disableSelfData.saemp == 0"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.ppNumber == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.ppNumber : enNameMap.ppNumber"
            >
              <Input
                :disabled="disableSelfData.ppNumber == 0"
                v-model="formItem.ppnumber"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.IssueCountry == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.IssueCountry : enNameMap.IssueCountry
              "
            >
              <Select
                :clearable="true"
                v-model="formItem.Issuecountry"
                :disabled="disableSelfData.IssueCountry == 0"
              >
                <Option
                  v-for="item in PassportIC"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.ppExpireDate == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.ppExpireDate : enNameMap.ppExpireDate
              "
            >
              <DatePicker
                :disabled="disableSelfData.ppExpireDate == 0"
                type="date"
                v-model="formItem.ppexpiredate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.ppIssueCountry == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.ppIssueCountry
                  : enNameMap.ppIssueCountry
              "
            >
              <Select
                :clearable="true"
                v-model="formItem.ppissuecountry"
                :disabled="disableSelfData.ppIssueCountry == 0"
              >
                <Option
                  v-for="item in nationalityList"
                  :value="item.code"
                  :key="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.payRollid == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.payRollid : enNameMap.payRollid"
            >
              <Input
                :disabled="disableSelfData.payRollid == 0"
                v-model="formItem.payrollid"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.atsid == '1'">
            <FormItem :label="lang == 'zh' ? chNameMap.atsid : enNameMap.atsid">
              <Input
                :disabled="disableSelfData.atsid == 0"
                v-model="formItem.atsid"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.competenceSystemid == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.competenceSystemid
                  : enNameMap.competenceSystemid
              "
            >
              <Input
                :disabled="disableSelfData.competenceSystemid == 0"
                v-model="formItem.competence_systemid"
              />
            </FormItem>
          </div>
          <div class="formCol"></div>
        </div>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" :disabled="isClick" @click="saveData()">保存</Button>
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      oldFormItem: {},
      formItem: {
        hiresociety: "1",
        servicestatus: ""
      },
      workStatus: [],
      personnelStatus: [],
      personnelLevel: [],
      partisanList: [],
      PersonnelBackground: [],
      PassportIC: [],
      nationalityList: [],
      retireClass: [],
      HOLIDAYCLASS: [],
      ANLVCLASS: [],
      loading: false,
      issyadjust: null,
      isswadjust: null,
      inprobation: null,
      tempemp: null,
      expatriate: null,
      labourworker: null,
      saemp: null,
      BeginningdateService: [
        {
          value: "0",
          label: "雇佣日"
        },
        {
          value: "1",
          label: "有效雇佣日"
        }
      ],
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      id: null,
      plan: null,
      userId: ""
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    isClick() {
      return JSON.stringify(this.getNewValue()) == "{}" 
    }
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1"
      };
      this.loading = true;
      axios
        .post("/PersonnelInformation/searchUserPersonnelInformation", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.formItem = res.data.length > 0 ? res.data[0] : {};
            for (var item in this.formItem) {
               if (typeof(this.formItem[item]) == 'string'  && this.formItem[item].indexOf('1900-01-01') != -1) {
                this.formItem[item] = ''
               }
            }
            this.oldFormItem = JSON.parse(JSON.stringify(this.formItem));
            this.showSelfData = res.showSelfData;
            console.log(this.showSelfData, "111");
            this.disableSelfData = res.disableSelfData;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.workStatus = res.optionData.SERVICESTATUS;
            this.personnelStatus = res.optionData.HRSTATUS;
            this.partisanList = res.optionData.PARTY;
            this.PersonnelBackground = res.optionData.INHABITANT;
            this.nationalityList = res.optionData.PPISSUECOUNTRY;
            this.PassportIC = res.optionData.ISSUECOUNTRY;
            this.personnelLevel = res.optionData.HRLEVEL;
            this.retireClass = res.optionData.RETIRECLASS;
            this.HOLIDAYCLASS = res.optionData.HOLIDAYCLASS;
            this.ANLVCLASS = res.optionData.ANLVCLASS;
            // this.formItem.retirementYears 离退休年限
            var myDate = new Date();
            if (this.formItem.birthday !== "" && this.formItem.gender !== "") {
              var birthAbs =
                Math.abs(myDate - new Date(this.formItem.birthday)) /
                1000 /
                24 /
                60 /
                60;
              var year = birthAbs / 365;
              if (this.formItem.gender == "M") {
                this.formItem.retirementYears = Math.abs(60 - year).toFixed(1);
              } else {
                this.formItem.retirementYears = Math.abs(50 - year).toFixed(1);
              }
            }
           this.formItem.retirementYears && ( this.oldFormItem.retirementYears = JSON.parse(JSON.stringify(this.formItem.retirementYears)))
          }
        });
    },
    getCompanyFront() {
      var myDate = new Date();
      var yearabs = this.getyearDifference(this.formItem.hiredate, myDate);
      this.formItem.companyAgeFront = yearabs;
      this.$set(this.formItem, "companyAgeFront", yearabs);
    },
    getCompanyAfter() {
      var yearnum =
        Number(this.formItem.companyAgeFront) + Number(this.formItem.syadjust);
      yearnum = yearnum.toFixed(1);
      this.$set(this.formItem, "companyAgeAfter", yearnum);
    },
    getsocialFront() {
      var myDate = new Date();
      var yearabs = this.getyearDifference(this.formItem.hiresociety, myDate);
      this.formItem.socialAgeFront = yearabs;
      this.$set(this.formItem, "socialAgeFront", yearabs);
    },
    getsocialAfter() {
      var yearnum =
        Number(this.formItem.socialAgeFront) + Number(this.formItem.swadjust);
      yearnum = yearnum.toFixed(1);
      this.$set(this.formItem, "socialAgeAfter", yearnum);
    },
    // 获取两个年份的年分差
    getyearDifference(a, b) {
      (a = new Date(a)), (b = new Date(b));
      var daysDifference = Math.abs(a - b) / 1000 / 24 / 60 / 60;
      var yearDifference = Math.abs(daysDifference / 365).toFixed(1);
      return yearDifference;
    },
    getNewValue() {
      let obj = {};
      for (var item in this.formItem) {
        if (this.oldFormItem[item] != this.formItem[item]) {
          if (this.formItem[item] instanceof Date) {
              this.formItem[item] = this.date.dateVal(this.formItem[item], "YYYY-MM-DD")
          }
          if (typeof this.oldFormItem[item] == "object") {
            if (
              this.oldFormItem[item].join("") != this.formItem[item].join("")
            ) {
              console.log(item, "typeof(this.oldFormItem[item])");
              obj[item] = this.formItem[item];
            }
          } else {
            obj[item] = this.formItem[item];
          }
        }
      }
      return obj;
    },
    saveData() {
      if (this.formItem.retirementYears) {
          this.formItem.retirement_years = this.formItem.retirementYears
          this.$delete(this.formItem,'retirementYears')
      }
      let newFormItem = this.getNewValue();
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan ? this.plan : this.userId,
            ...newFormItem,
          };
          axios
            .post("/PersonnelInformation/rollBackUserPersonnelInformation", obj)
            .then(res => {
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/PersonnelInformation.vue